import React from 'react';
import { useAuth } from './AuthContext';

const withAuth = (WrappedComponent) => (props) => {
  const auth = useAuth();
  return <WrappedComponent {...props} auth={auth} />;
};

export default withAuth;